import React from "react"

const SceneLevelItem = props => {
  const { img } = props;
  return (
    <div className="scene-level-item">
      <img src={img} alt="level" className="scene-level-item-image"/>
    </div>
  )
};

export default SceneLevelItem